import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.LeagueTable = class LeagueTable extends Snappy.BaseComponent {
    static get tagName() {
        return 'league-table';
    }

    constructor(element) {
        super(element);
    }

    render() {
        let wrapper = $(".league-table");

        wrapper.find($(".key-toggle")).click(function () {
            wrapper.find($(".key-div")).toggle();
            if (wrapper.find($(".key-div")).is(":visible")) {
                $(".key-toggle .show-hide-text").text($("#hideKeyText").val());
                $(".key-toggle").addClass('invert');
            } else {
                $(".key-toggle .show-hide-text").text($("#showKeyText").val());
                $(".key-toggle").removeClass('invert');
            }
        });

        wrapper.find($(".filters-toggle")).click(function () {
            wrapper.find($(".filters")).toggle();
        });

        wrapper.find($(".competitionsList")).change(function () {
            UserSelection.selectCompetition(this);
        });

        wrapper.find($(".seasonsList")).change(function () {
            UserSelection.selectSeason(this);
        })

        $(window).resize( function () {
            $('select').blur();
        });
        
        var CommonMethods = function () {

           var _getVerificationToken = function getVerificationToken(form) {
                return form.find('input[name=__RequestVerificationToken]').val();
            };
            return {
                getVerificationToken: _getVerificationToken
            };
        }();
        //*************************** Event registered to handle HTTP-POST & HTTP-GET **************************
        var HttpService = function () {

            var _httpGet = function (serviceName, serviceDatatype, successCallback, errorCallback, sender) {
                var datatype = serviceDatatype !== "" ? serviceDatatype : "json";
                $.ajax({
                    url: '/api/sitecore/' + serviceName,
                    type: "GET",
                    dataType: datatype,
                    headers: {
                        "__RequestVerificationToken-FA": CommonMethods.getVerificationToken($('#subscribe-form'))
                    },
                    cache: false,
                    beforeSend: function () {
                        $(".loader").removeClass('hide');
                    },
                    success: function (data) {
                        successCallback(data, sender);
                    },
                    error: function (jqXHR, status, errorMessage) {
                        // errorCallback(jqXHR);
                        console.log(errorMessage);
                    },
                    complete: function () {
                        $(".loader").addClass('hide');
                    }
                });
            },

                _httpPost = function (serviceName, serviceDatatype, dataInput, successCallback, errorCallback, sender) {
                    var datatype = serviceDatatype !== "" ? serviceDatatype : "json";
                    $.ajax({
                        url: '/api/sitecore/' + serviceName,
                        type: "POST",
                        headers: {
                            "__RequestVerificationToken-FA": CommonMethods.getVerificationToken($('#subscribe-form'))
                        },
                        dataType: datatype,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function () {
                        },
                        success: function (data) {
                            successCallback(data, sender);
                        },
                        error: function (jqXHR, status, errorMessage) {
                            errorCallback(jqXHR);
                        },
                        complete: function () {
                        }
                    });
                };

            return {
                httpPost: _httpPost,
                httpGet: _httpGet
            };
        }();

        var UserSelection = function () {
            console.log('Text');
            var context = undefined;
            var _init = function (ref) {
                context = ref;
            };
            var _selectSeason = function (ref) {
                var url = $("#divisionSeasonUrl").val() + "?seasonId=" + $(".seasonsList").val();
                HttpService.httpGet(url, 'html', _updateDivisionSeasonDropdown, ref);

            },
            _selectCompetition = function (ref) {
                var url = $("#leagueStatsUrl").val() + "?divisionSeasonId=" + $(".competitionsList").val() + "&seasonId=" + $(".seasonsList").val();
                HttpService.httpGet(url, 'html', _updateLeagueStatsForDevisionSeason, ref);
            },
            _updateDivisionSeasonDropdown = function (data, ref) {
                var obj = JSON.parse(data);
                if (obj != null) {
                    $('.competitionsList').empty();
                    var buildHtml = '';
                    obj.forEach(function (i) {
                        buildHtml += '<option value="' + i.divisionSeasonID + '">' + i.publishedDivisionDesc + '</option>';
                    });
                    $('.competitionsList').html(buildHtml);
                    _selectCompetition();
                }
            },
            _updateLeagueStatsForDevisionSeason = function (data, ref) {

                $('#scLeagueTable').html(data);
            };
            return {
                init: _init,
                selectCompetition: _selectCompetition,
                selectSeason: _selectSeason

            };

        }();

    };


}






// WEBPACK FOOTER //
// ./components/leagueTable/scripts/league-table.js